/* eslint-disable */
import * as React from 'react';

const UsageImage = ({ children: children}) => {

        return (
        <div className="usgBlkImg">
            {children}
        </div>
 
        )
    };
     
export default UsageImage;







